import React from 'react'
import {Link} from 'react-router-dom'


export default class Footer extends React.Component{
    render(){
        return <div className={'footer-container'}>
            <div className={'footer-container-sub'}>
                <div className={'footer-info from-our-blog'}>
                    <div className={'from-our-blog-sub'}>
                        <div className={'title logo'}></div>
                        <div className={'footer-menu'}>
                            <div className={'footer-info product'}>
                                <div className={'title'}>Hubbler</div>
                                <ul>
                                    <li><Link to={'/solutions/sales/'}>Fit.Sales</Link></li>
                                    <li><Link to={'/customerSupport'}>Customer Support</Link></li>
                                    <li><a href="https://help.hubbler.mobi/faq/" target="_blank">FAQs</a></li>
                                </ul>
                            </div>
                            <div className={'footer-info infoformation'}>
                                <div className={'title'}>Company</div>
                                <ul>
                                    <li><Link to={'/company/aboutus'}>About Us</Link></li>
                                    <li><Link to={'/company/leadership-team'}>Leadership Team</Link></li>
                                    <li><Link to={'/career'}>Careers</Link></li>
                                    <li><Link to={'/contactUs'}>Contact Us</Link></li>
                                    <li><Link to={'/privacypolicy'}>Privacy Policy</Link></li>
                                    <li><Link to={'/termsofuse'}>Terms of Use</Link></li>
                                </ul>
                            </div>
                            <div className={'footer-info infoformation'}>
                                <div className={'title'}>Solutions</div>
                                <ul>
                                    <li><Link to={'/solutions/employee-engagement'}>Employee Engagement</Link></li>
                                    <li><Link to={'/solutions/community-engagement'}>Community Engagement</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>


                <div className={'footer-info about-us'}>
{/*
                    <div className={'title'}>About Us</div>
*/}
                    <ul className={'trems-and-policy'}>
                       <li>
{/*
                            Nullam quis risus eget urna mollis ornare vel eu leo. Praesent commodo cursus magna, vel scelerisque.
*/}
                        </li>
                        <li>
                            <a href="" className={'logo twitter'}></a>
                            <a href="https://www.facebook.com/hubbler.mobi/" className={'logo facebook'} target="_blank"></a>
                            <a href="https://www.linkedin.com/company/hubbler.mobi/" className={'logo google'} target="_blank"></a>
                        </li>
                        <li className={'trems-and-policy-li'}>
                            {/*<Link to={'/privacypolicy'}>Privacy Policy</Link>
                            <Link to={'/termsofuse'}>Terms of Use</Link>*/}
                            <div className={'make-india'}></div>

                        </li>
                        <li className={'socail-media'}>
                            <a className={'apple'} href="https://itunes.apple.com/in/app/hubbler/id1190887110?mt=8" target="_blank"></a>
                            <a className={'google'} href="https://play.google.com/store/apps/details?id=mobi.hubbler.app" target="_blank"></a>
                        </li>
                        <li className={'make-india-li'}>
                            <div className={'make-india'}></div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/Footer.js